import React, { useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Select from 'react-select';
import PageHeader from '../../../common/page-header';
import Paper from '@mui/material/Paper';
import moment from "moment";
import { useForm } from 'react-hook-form';

import {
    Backdrop,
    Button,
    Card,
    CircularProgress,
    Divider,
    List,
    Box,
    Modal,
    IconButton,
    ListItemIcon,
    TextareaAutosize,
    ListItem,
    ListItemText,
    InputLabel,
    TextField,
    Typography
} from "@mui/material";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    maxHeight: '80vh',
    borderRadius: '8px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

const options = [
    { value: 'option1', label: 'Hobbie' },
    { value: 'option2', label: 'Learning' },
    { value: 'option3', label: 'Intermediate' },
    { value: 'option4', label: 'Professional' },
    { value: 'option5', label: 'Master' },
];

function SkillandHobbies() {

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleSubmit = (event) => {
        event.preventDefault();

        handleClose();
    };
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            padding: '8px' // set the padding value to 10px
        })
    };
    return (
        <div>
            <PageHeader title={`Skills and Hobbies `} />
            <div className='flex' style={{ width: '100', display: 'flex', justifyContent: "end", marginRight: 10 }}>
                < Button variant="contained" sx={{ width: "180px", }}
                    onClick={handleOpen}  >Add Skills & Hobbies</Button >
            </div>


            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h4" component="h2" sx={{ textAlign: "center", pb: 5 }}>
                        Add Skill or Hobbie
                    </Typography>
                    <form onSubmit={handleSubmit}>


                        <TextField
                            aria-label="empty textarea"
                            placeholder="Enter Skill or Hobbie"
                            multiline
                            autoFocus
                            style={{ width: "100%", marginTop: 8, marginBottom: 16 }}
                        />


                        <Select options={options} required styles={customStyles} placeholder={"Select Expertise Level"} />
                        <div style={{ display: "flex", justifyContent: "end" }}>
                            <Button
                                variant="contained"
                                type="submit"
                                sx={{
                                    mt: 2, mr: 2,
                                    background: "gray",
                                    '&:hover': {
                                        backgroundColor: 'gray',
                                    },
                                }}
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>

                            <Button variant="contained" type="submit" sx={{ mt: 2 }}>
                                Submit
                            </Button>

                        </div>
                    </form>

                </Box>
            </Modal>



            <Card sx={{ mt: 5 }} variant="outlined">
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>NO</TableCell>
                                <TableCell>Skills</TableCell>
                                <TableCell>Expertise</TableCell>
                                <TableCell>Hobbies</TableCell>
                                <TableCell> </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            <TableRow

                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, marginTop: 5 }}
                            >
                                <TableCell>1</TableCell>
                                <TableCell>Web development
                                </TableCell>
                                <TableCell>Intermediate</TableCell>
                                <TableCell>Learning</TableCell>
                                <TableCell>delete</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

            </Card>
        </div >
    )
}

export default SkillandHobbies
